const be = {
  "भाजपा सदस्यता अभियान - 2024": "বিজেপি সদস্যতা অভিযান - 2024",
  "Select Language": "ভাষা নির্বাচন করুন",
  Next: "পরবর্তী",
  "Enter your mobile number": "আপনার মোবাইল নম্বর লিখুন",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "আমি শর্তাবলী গ্রহণ করছি, এবং অব্যাহত রেখে, আমি স্বেচ্ছায় বিজেপির সদস্য হতে সম্মত হচ্ছি।",
  "Get OTP": "OTP পান",
  "Terms and Conditions": "শর্তাবলী",
  "You must tick the box to continue, as it is mandatory.":
    "আপনাকে চালিয়ে যেতে বাক্সে টিক দিতে হবে, কারণ এটি বাধ্যতামূলক।",
  "Okay, Got it": "ঠিক আছে, বুঝেছি",
  "Get OTP": "OTP পান",
  "Enter OTP": "OTP লিখুন",
  "Resend OTP": "OTP আবার পাঠান",
  Continue: "চালিয়ে যান",
  "Fill details": "বিবরণ পূরণ করুন",
  "Upload Photo": "ছবি আপলোড করুন",
  "Profile Photo": "প্রোফাইল ছবি",
  "Mobile number": "মোবাইল নম্বর",
  "Mrs.": "মিসেস",
  "Mr.": "মি",
  Ms: "সুশ্রী",
  "Full Name*": "পুরো নাম*",
  "D.O.B": "ডিওবি",
  Age: "বয়স",
  Gender: "লিঙ্গ",
  Female: "মহিলা",
  Male: "পুরুষ",
  Other: "অন্যান্য",
  "Email Id": "ইমেইল আইডি",
  "Add address": "ঠিকানা যোগ করুন",
  "House/ Flat/ Floor No.": "বাড়ি/ ফ্ল্যাট/ ফ্লোর নং।",
  "Current address PIN code": "বর্তমান ঠিকানা পিন কোড",
  "District*": "জেলা*",
  State: "রাজ্য",
  "Assembly constituency (AC)": "বিধানসভা কেন্দ্র (এসি)",
  "Tell us about your location": "আপনার অবস্থান সম্পর্কে আমাদের বলুন",
  "It will assist us in locating other members in your area.":
    "এটি আপনার এলাকায় অন্যান্য সদস্যদের সনাক্ত করতে আমাদের সহায়তা করবে।",
  "Your address as fetched": "আপনার ঠিকানা সংগ্রহ করা হয়েছে",
  "Referral code": "রেফারেল কোড",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "আমি প্রত্যয়িত করছি যে উপরে প্রদত্ত তথ্য সঠিক এবং কোন ভুল নেই। আমি জানি যে সমস্ত পরবর্তী যোগাযোগ উপরে প্রদত্ত বিবরণে করা হবে",
  Save: "সংরক্ষণ করুন",
  Select: "নির্বাচন করুন",
  Camera: "ক্যামেরা",
  or: "বা",
  Gallery: "গ্যালারি",
  "Support format : Jpeg, Png, Pdf": "সমর্থন বিন্যাস: Jpeg, Png, Pdf",
  Cancel: "বাতিল করুন",
  "Select location": "অবস্থান নির্বাচন করুন",
  "Provide location": "অবস্থান প্রদান করুন",
  "Search results": "অনুসন্ধানের ফলাফল",
  "Search for a building, street name or..":
    "একটি বিল্ডিং, রাস্তার নাম বা.. অনুসন্ধান করুন",
  "Your address as fetched": "আপনার ঠিকানা সংগ্রহ করা হয়েছে",
  "Locate me": "আমাকে সনাক্ত করুন",
  "Confirm location": "অবস্থান নিশ্চিত করুন",
  "Congratulations !": "অভিনন্দন!",
  "Your primary Id is -": "আপনার প্রাথমিক আইডি হল-",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "আপনার ডেটা উন্নত করতে, আপনার আইডি কার্ড অ্যাক্সেস করতে, এবং প্রাথমিক সদস্য হিসাবে যোগদানের জন্য অন্যদের উল্লেখ করতে Bjp.org/membership-এ লগইন করুন।",
  "ID CARD": "আইডি কার্ড",
  "You can download your generated ID Card":
    "আপনি আপনার তৈরি আইডি কার্ড ডাউনলোড করতে পারেন",
  Download: "ডাউনলোড করুন",
  "Go to dashboard": "ড্যাশবোর্ডে যান",
  "View your profile": "আপনার প্রোফাইল দেখুন",
  "Refer and add member": "সদস্য রেফার করুন এবং যোগ করুন",
  Share: "শেয়ার করুন",
  "To update your additional details and refer more member, please click here.":
    "আপনার অতিরিক্ত বিবরণ আপডেট করতে এবং আরও সদস্যের উল্লেখ করতে, অনুগ্রহ করে এখানে ক্লিক করুন।",
  "Bharatiya Janata Party": "ভারতীয় জনতা পার্টি",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6এ, দীনদয়াল উপাধ্যায় মার্গ, নতুন দিল্লি - 110002",
  Name: "নাম",
  State: "রাজ্য",
  "Membership Number": "সদস্য সংখ্যা",
  "QR Code": "QR কোড",
  "Please select a year between 1930 and 2006.":
    "অনুগ্রহ করে ১৯৩০ থেকে ২০০৬ এর মধ্যে কোনো একটি বছর নির্বাচন করুন ",
  "Please enter a valid email address.":
    "অনুগ্রহ করে সঠিক ইমেইল  আইডিটি লিখুন ",
  "Please enter 6-digit PIN code.": "অনুগ্রহ করে ৬ ডিজিটের পিন কোডটি লিখুন ",
  "10-digit mobile number.": "১০ ডিজিট মোবাইল নম্বর ",
  "Please enter a 10-digit mobile number.":
    "অনুগ্রহ করে ১০ ডিজিটের  মোবাইল নম্বরটি লিখুন  ",
  "Please enter your name.": "অনুগ্রহ করে আপনার নামটি লিখুন ",
  "I pledge and willing to receive regular updates from BJP":
    "আমি অঙ্গীকার করছি এবং বিজেপি থেকে নিয়মিত আপডেট পেতে ইচ্ছুক",
  "Get Verification Code": "যাচাইকরণ কোড পান",
  "Enter Verification Code": "যাচাইকরণ কোড লিখুন",
  "Resend Verification Code": "যাচাইকরণ কোড পুনরায় পাঠান",
  "Provide Details": "বিস্তারিত প্রদান করুন",
  Upload: "আপলোড করুন",
  Ok: "ঠিক আছে",
  Calendar: "ক্যালেন্ডার",
  "Full Address": "সম্পূর্ণ ঠিকানা",
  "Privacy policy": "গোপনীয়তার নীতি ",
  Disclaimer: "ডিসক্লেমার",
  "Contact us": "আমাদের সঙ্গে যোগাযোগ করুন",
  Save: "সেভ করুন",
  "Your primary member ID": "আপনার প্রাথমিক সদস্য আইডি",
  "Membership Card": "সদস্য কার্ড",
  "Your Unique Referral code": "আপনার ইউনিক  রেফারেল কোড",
  "Invite and add member": "আমন্ত্রণ জানান এবং সদস্য যোগ করুন",
  Share: "শেয়ার করুন",
  "Click below to add more details, donate and add other members to BJP":
    "নিজের সম্পর্কে আরও বিশদে জানাতে, দান করতে এবং অন্য সদস্যদের বিজেপিতে যোগদান করাতে নিচে ক্লিক করুন",
  "Update your details": "আপনার বিবরণ আপডেট করুন",
  "Add Referral Details": "রেফারেল বিবরণ যোগ করুন",
  "Referred by (name)": "(নাম) দ্বারা উল্লেখিত",
  "Referred by (mobile number)": "উল্লেখিত (মোবাইল নম্বর)",
  Capture: "ছবি তুলুন",
  "Close Camera": "ক্যামেরা বন্ধ করুন",
  Uploading: "আপলোড হচ্ছে",
  "Your Unique Referral Link": "আপনার ইউনিক  রেফারেল লিঙ্ক",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "আপনি আজকের জন্য সর্বোচ্চ OTP প্রচেষ্টা করে ফেলেছেন । আগামীকাল আবার চেষ্টা করুন",
  Miss: "সুশ্রী",
  "Full Name": "পুরো নাম",
  "OTP limit reached for today. Please try again tomorrow":
    "আজকের জন্য ওটিপির লিমিট শেষ হয়ে গেছে , আবার কাল চেষ্টা করুন",
  ": is not a Primary Member, Only Primary Members can refer":
    ": এটি প্রাইমারি মেম্বার নয় , শুধু প্রাইমারি মেম্বাররা রেফার করতে পারবে",
  "Please enter valid fullname": "বৈধ পূর্ণনাম লিখুন",
  Upload: "আপলোড করুন",
};

export default be;
